import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Tooltip, Zoom } from '@material-ui/core';
import './styles.css';
import Heading from '../../UI/Texts/Heading';
import Paragraph from '../../UI/Texts/Paragraph';
import { formatMoney } from '../../Common/decimalHelper';

const ClientazoTooltip = withStyles((theme) => ({
  tooltip: {
    background: '#EFF0F8 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '4px',
    padding: '0px',
    opacity: '1 !important',
    margin: '7px 0 4px 25px !important'
  },
}))(Tooltip);

const VisualizadorPrecio = ({ precioLista, precioPromocional, porcentajeDescuentoFullCatalogo }) => {
  const tienePromocionValida = precioPromocional && precioPromocional < precioLista;

  const getPrecioPartes = (precio) => {
    if (precio === null || precio === undefined) return null;
    const formatted = formatMoney(precio);
    const parts = formatted.split(',');
    return {
      entero: parts[0],
      decimal: parts[1],
    };
  };

  const renderPrecioFormateado = (precio) => {
    const precioPartes = getPrecioPartes(precio);
    if (!precioPartes) return '';

    if (precioPartes.decimal && precioPartes.decimal !== '00') {
      return (
        <span className="vp-precioContenedor">
          <span className="vp-precioEntero">{precioPartes.entero}</span>
          <span className="vp-precioDecimales">{precioPartes.decimal}</span>
        </span>
      );
    }

    return (
      <span className="vp-precioContenedor">
        <span className="vp-precioEntero">{precioPartes.entero}</span>
      </span>
    );
  };

  const renderPrecioNormal = (precio) => {
    const precioPartes = getPrecioPartes(precio);
    if (!precioPartes) return '';

    if (precioPartes.decimal && precioPartes.decimal !== '00') {
      return `${precioPartes.entero},${precioPartes.decimal}`;
    }

    return precioPartes.entero;
  };

  return (
    <div className='visualizadorPrecio'>
      {tienePromocionValida ? 
      <Paragraph size='medium' weight='semi_bold'>
        Antes <span className='precioTachado vp-precioNormal'>{renderPrecioNormal(precioLista)}</span>
      </Paragraph> 
      :
      <>
      {porcentajeDescuentoFullCatalogo > 0? 
        <Paragraph size='medium' weight='semi_bold'>
        <span className='precioTachado vp-precioNormal'>{renderPrecioNormal(precioLista)}</span>
        </Paragraph>
      :
      <Heading tag='h3' weight='bold'>
        {renderPrecioFormateado(precioLista)}
      </Heading>
      }
      </>
      }
      {tienePromocionValida &&
      <Heading tag='h3' weight='bold'>{renderPrecioFormateado(precioPromocional)}</Heading>      
      }

      {(precioPromocional === null && porcentajeDescuentoFullCatalogo && porcentajeDescuentoFullCatalogo > 0) ? <Heading tag='h3' weight='bold'>{renderPrecioFormateado(precioLista-precioLista*porcentajeDescuentoFullCatalogo/100)}</Heading> : <span></span>}
    </div>
  );
};

VisualizadorPrecio.defaultProps = {
  precioLista: 0,
  precioPromocional: undefined
};

VisualizadorPrecio.propTypes = {
  precioLista: PropTypes.number,
  precioPromocional: PropTypes.number,
};

export default VisualizadorPrecio;
